import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { TitleHeader } from "../../../TitleHeader";
import { Link } from "react-router-dom";
import { colors } from "../../../../utils/theme";
import styled from "styled-components";
import SingleSessionForm from "./SesionPatient/SingleSessionForm";
import OrderFormPatient from "./SesionPatient/OrderFormPatient";
import InfoPatientForm from "./SesionPatient/InfoPatientForm";
import { useDataContex } from "../../../../hooks/Context/PatientProvider";
import { useNavigate } from "react-router-dom";

const Session = styled.div`
  width: 90%;
  background-color: #f9f9f9;
  margin: 0 auto;
  border-radius: 10px;
  padding-bottom: 2rem;
  box-shadow: 1px 1px 5px 1px #00000029;

  .NoHayOrdenes {
    text-align: center;
    color: #857b7b;
  }

  .container_title {
    display: flex;
    background-color: ${colors.gris};
    padding: 1rem;
    justify-content: center;
    align-items: center;
    margin: 2rem 0;
  }

  .title2 {
    color: ${colors.primary};
    text-align: center;
    align-self: center;
    font-size: 1.5rem;
    font-weight: bold;
    @media (max-width: 600px) {
      font-size: 1.5rem;
    }
    @media (max-width: 375px) {
      font-size: 1.4rem;
    }
  }
`;

const ContainerOrder = styled.div`
  .paginator {
    padding: 1rem;
    display: flex;
    background-color: ${colors.gris};
    border-radius: 10px 10px 0 0;
    margin-bottom: 2rem;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 550px) {
      flex-direction: column;
    }
  }

  .title1 {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
    @media (max-width: 500px) {
      text-align: center;
    }
  }

  .arrow {
    .bx {
      background-color: ${colors.blanco};
      font-size: 2rem;
      color: ${colors.primary};
      border-radius: 50%;
      cursor: pointer;
    }
  }
`;

const SessionsComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  interface Sesion {
    hora: string;
    fechaAtencion: string;
    espacioAtencion: string;
    schedId: number;
    secterapia: string;
  }
  const { patientInfoContinuidadContex, setPatientInfoContinuidadContex } =
    useDataContex();
  const [sesionsOrder, setSesionsOrder] = useState<Sesion[]>([]);

  const { PatientOrderSession } = location.state;

  useEffect(() => {
    if (location.state) {
      setSesionsOrder(PatientOrderSession.orders.sesiones);
    }
    if (!patientInfoContinuidadContex) {
      navigate("/CancelarCita");
    }
  }, [location.state]);

  const eliminarSesion = (schedId) => {
    // Convertir schedId a número si es necesario
    const schedIdNum = Number(schedId);

    // Buscar la sesión a eliminar
    const sesionAEliminar = sesionsOrder.find(
      (sesion) => sesion.schedId === schedIdNum
    );
    // console.log("Sesión a eliminar:", sesionAEliminar);

    // Actualizar el estado para eliminar la sesión
    setSesionsOrder((sesionesActuales) => {
      const nuevasSesiones = sesionesActuales.filter(
        (sesion) => sesion.schedId !== schedIdNum
      );
      return nuevasSesiones;
    });

    let shouldNavigate = false;
    let updatedSesionesSinOrden =
      patientInfoContinuidadContex?.sesionesSinOrden;

    if (PatientOrderSession.orders.numeroDeOrden === 0) {
      const updatedSessions = updatedSesionesSinOrden?.sesiones.filter(
        (sesion) => {
          console.log(sesion); // Imprime cada sesion
          return Number(sesion.schedId) !== Number(schedId);
        }
      );
      if (updatedSessions?.length === 0) {
        shouldNavigate = true;
      }
      updatedSesionesSinOrden = {
        ...updatedSesionesSinOrden,
        sesiones: updatedSessions,
      };
    }

    const updatedOrders = patientInfoContinuidadContex?.orders
      .map((order) => {
        if (order.numeroDeOrden === PatientOrderSession.orders.numeroDeOrden) {
          const updatedSessions = order.sesiones.filter(
            (sesion) => sesion.schedId !== Number(schedId)
          );
          if (updatedSessions.length === 0) {
            shouldNavigate = true;
          }
          return { ...order, sesiones: updatedSessions };
        }
        return order;
      })
      .filter((order) => order.sesiones.length > 0);

    // Actualiza el estado con las órdenes y sesionesSinOrden actualizadas
    setPatientInfoContinuidadContex({
      ...patientInfoContinuidadContex,
      orders: updatedOrders,
      sesionesSinOrden: updatedSesionesSinOrden,
    });

    if (shouldNavigate) {
      navigate("/OrdenesVigentes");
    }
  };

  const isNotoOrder = Number(PatientOrderSession.orders.orden) === 0;

  return (
    <div>
      <div className="sesionContainer">
        <TitleHeader />
        <Session>
          <ContainerOrder>
            <div className="paginator">
              <Link className="arrow" to="/OrdenesVigentes">
                <i className="bx bx-chevron-left"></i>
              </Link>
              <span className="title1">INFORMACIÓN SESIONES</span>
              <div></div>
            </div>

            {sesionsOrder.map((sesion, index) => (
              <SingleSessionForm
                key={index}
                sesion={sesion}
                onEliminarSesion={eliminarSesion}
              />
            ))}

            {isNotoOrder ? (
              <div></div>
            ) : (
              <div>
                <div className="container_title">
                  <span className="title2">ORDEN MÉDICA</span>
                </div>
                <OrderFormPatient patient={PatientOrderSession.orders} />
              </div>
            )}
            <div className="container_title">
              <span className="title2">INFORMACIÓN DEL PACIENTE</span>
            </div>
            <InfoPatientForm patient={PatientOrderSession} />
          </ContainerOrder>
        </Session>
      </div>
    </div>
  );
};

export default SessionsComponent;
